import { SWRConfiguration } from 'swr';

import {
  GET_LONG_ABSENCES_SWR_KEY,
  LongAbsence,
  getLongAbsences,
} from '~/data/absences/index';
import { UseSWROutput, useSWR } from '~/hooks/useSWR';

type PropsType = {
  employeeId: number;
  period?: 'historical';
};

export const useGetLongAbsences = (
  props: PropsType,
  swrConfig?: SWRConfiguration,
  disable?: boolean,
): UseSWROutput<LongAbsence[]> => {
  const { employeeId, period } = props;

  const isEnabled = !disable;

  return useSWR(
    isEnabled ? [GET_LONG_ABSENCES_SWR_KEY, employeeId, period] : null,
    ([key_, employeeId]) => getLongAbsences(employeeId, period),
    swrConfig,
  );
};
